export default "__VITE_ASSET__Bj4xbv6a__"